import { PaginatedResponse } from "@interfaces/response/paginated-response.interface";
import { getRequest } from "api/base-services.request";

import { IRealestateResponseData } from "shared/models/interfaces/response/realestate.interface";

export function getLastedPropertySee(params?: any) {
  return getRequest<PaginatedResponse<IRealestateResponseData[]>>(
    "/v2/realestates/last-visited",
    params
  ).then(({ data }) => data);
}
